import * as React from 'react';
import { ReactComponent as TakeTimeTalksIcon } from "assets/icons/ql-take-time-talks.svg";
import { ReactComponent as IdeasHubIcon } from "assets/icons/ql-ideas-hub.svg";
import { ReactComponent as SuccessFactorsIcon } from "assets/icons/ql-success-factors.svg";
import { ReactComponent as FioriIcon } from "assets/icons/ql-fiori.svg";
import { ReactComponent as WebMailIcon } from "assets/icons/ql-webmail.svg";
import LockIcon from "@mui/icons-material/Lock";
import { QuickLinksH1 } from "components/menu/Labels";
import { Box, Grid2 } from "@mui/material";
import { openInANewBrowser } from 'helpers/HelperFunctions';

export interface IQuickLinkItem {
    icon: any,
    title: React.ReactNode,
    className: string,
    url: string
}

export const QuickLink = (props: { item: IQuickLinkItem }) => {
    const Icon = props.item.icon;

    const onClick = () => {
        openInANewBrowser(props.item.url);
    };

    return (
        <div className="quick-link clickable" onClick={onClick}>
            <Box className="bullet" />
            <div className="icon-container center-children-both"><Icon className="icon" /></div>
            <span className="label center-children-vertically"><span>{props.item.title}</span></span>
        </div>
    );
};

export const QuickLinksData = [
    { title: "Field Leadership", className: "take-time", icon: TakeTimeTalksIcon, url: "https://flex.bhp.com/"},
    { title: "Ideas Hub", className: "ideas-hub", icon: IdeasHubIcon, url: "https://ideas.bhp.com/"},
    { title: "People System", className: "success-factors", icon: SuccessFactorsIcon, url: "https://performancemanager8.successfactors.com" },
    { title: "Fiori", className: "fiori", icon: FioriIcon, url: "https://mobile.bhp.com/fiori"},
    { title: "BHP Webmail", className: "web-mail", icon: WebMailIcon, url: "https://outlook.office.com" },
    { title: "Citrix", className: "citrix", icon: LockIcon, url: "https://opsnetapps.bhp.com" }
] as IQuickLinkItem[];

export const QuickLinksCard = () => {
    return (
        <div className="info-card">
            <Grid2 container>
                <Grid2 size={{ xs: 12 }}>
                    <QuickLinksH1 />
                </Grid2>
            </Grid2>

            <div className="mt-5"></div>

            {QuickLinksData.map((link, idx) =>
                <QuickLink key={idx} item={link} />
            )}
        </div>
    )
};

export default QuickLinksCard;